export default __webpack_public_path__ + "static/1992-02-22_factors_ICMPC.pdf";